import SetDefaultFilters from "./SetDefaultFilters";

export default SetDefaultFilters;
